export const DefaultUserIcon = ({ classes }) => (
  <svg className={classes} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx={18} cy={18} r="17.5" fill="#F9F9F9" stroke="#DADADA" />
    <path
      d="M24.4749 24.5C24.2189 21.145 21.4209 18.5 17.9999 18.5C14.5789 18.5 11.7809 21.145 11.5249 24.5"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18.5C19.933 18.5 21.5 16.933 21.5 15C21.5 13.067 19.933 11.5 18 11.5C16.067 11.5 14.5 13.067 14.5 15C14.5 16.933 16.067 18.5 18 18.5Z"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrowIcon = ({ classes, stroke = "#333", fill = "none" }) => (
  <svg className={classes} viewBox="0 0 18 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M0.75 9H17.25" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.75 15L0.75 9L6.75 3" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ExpandMoreIcon = ({ classes, stroke = "#333", fill = "none" }) => (
  <svg width={20} height={20} className={classes} viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M15 8L10 13L5 8" stroke={stroke} strokeMiterlimit={10} strokeLinecap="square" />
  </svg>
);

export const ToolTipIcon = ({ classes, stroke = "#333", fill = "none" }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00016 14.6654C4.31826 14.6654 1.3335 11.6806 1.3335 7.9987C1.3335 4.3168 4.31826 1.33203 8.00016 1.33203C11.682 1.33203 14.6668 4.3168 14.6668 7.9987C14.6668 11.6806 11.682 14.6654 8.00016 14.6654ZM8.00016 13.332C10.9457 13.332 13.3335 10.9442 13.3335 7.9987C13.3335 5.05318 10.9457 2.66536 8.00016 2.66536C5.05464 2.66536 2.66683 5.05318 2.66683 7.9987C2.66683 10.9442 5.05464 13.332 8.00016 13.332ZM7.3335 4.66536H8.66683V5.9987H7.3335V4.66536ZM7.3335 7.33203H8.66683V11.332H7.3335V7.33203Z"
      fill="black"
    />
  </svg>
);
